import {nestedProp} from '../../Utils/object'
import { sensorTypeName } from './Sensors';

const sensorGroups = [
  {type: ['50','51', '52', '54', '55', 'FD'], group: "totalizer"},
  {type: ['53', '5D',], group: 'encoder'},
  {type: ['71', '72',], group: 'allread'},
  {type: ['74',], group: 'umeter'},
  {type: ['58', '5B', '5C',], group: 'runtime'},
  {type: ['A0', 'A1', 'A2', 'A3', 'A4', 'A5', 'A6',], group: 'modbus'},
  {type: ['01', '02',], group : 'temperature'},
]

const editProps = [
  {memberOf: ['totalizer', 'encoder', 'allread', 'runtime', 'modbus'], dataKey: ".meter_type", stateKey: "utility"}, 
  {memberOf: ['totalizer', 'encoder', 'allread', 'umeter', 'runtime', 'modbus'], dataKey: ".meter_style", stateKey: "meter_style"},
  {memberOf: ['totalizer', 'encoder', 'runtime',], dataKey: ".units", stateKey: "units"},
  {memberOf: ['totalizer', 'encoder', 'runtime'], dataKey: ".factor", stateKey: "factor"},
  {memberOf: ['totalizer'], dataKey: ".initial_meter_read", stateKey: "imr"}, 
  {memberOf: ['totalizer'], dataKey:".initial_meter_time", stateKey:"imr_date"},
  {memberOf: ['totalizer', 'encoder', ], dataKey: ".meter_serial_number", stateKey: "serial_number"},
  {memberOf: ['totalizer', 'encoder', 'allread'], dataKey: ".note", stateKey: "note"},
  {memberOf: ['temperature' ], dataKey: ".units", stateKey: "temperature"},
]

export function typeToLockedProps (type) {
  const group = typeToEditGroup(type)
  return group === 'modbus' ? ['meter_serial_number', 'factor', 'units'] : []
}
export function typeToEditGroup (type) {
  const arrTemp = sensorGroups.filter(item => item.type.some(t => t === type?.toUpperCase()))
  return arrTemp.length > 0 ? arrTemp[0].group : undefined
}

export function groupToEditProps (group) {
  return editProps.filter (item => item.memberOf.some(g => g === group))
}

export function allEditProps() {
  return editProps
}

function validate (arr) {
  const step1 = arr?.filter(i => i!== undefined) ?? []
  return step1.map(i => i.toUpperCase())
}

export function InitSensorTypes (devices) {
  const slot0 = validate(devices?.map(item => nestedProp(item, "sensors.0.sensor_type")))
  const slot1 = validate(devices?.map(item => nestedProp(item, "sensors.1.sensor_type")))
  const uniqueTypes = [...new Set(slot0?.concat(slot1))]
  return uniqueTypes.filter(t => typeToEditGroup(t) !== undefined)
}
export function SensorNames(types) {
  return types.map(item => sensorTypeName(item))
}